module.exports = __webpack_public_path__ + "img/BG_Footer2.a0cebacf.png";